import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import { BASE_URL } from "./Constants.js";
import { useNavigate, useParams } from 'react-router-dom';

const Get_DressType = () => {
  const [newUser, setNewUser] = useState({
    dress_type: '',
    gender: ''
  });

  const [formError, setFormError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch profile
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  // Fetch dress type
  useEffect(() => {
    const fetchDressType = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}get_dress_types/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch dress type');

        const data = await response.json();
        setNewUser({
          dress_type: data.dressType.dress_type || '',
          gender: data.dressType.gender || ''
        });
      } catch (err) {
        setFormError(err.message);
      }
    };

    fetchDressType();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newUser.dress_type || !newUser.gender) {
      setFormError('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${BASE_URL}update_dress_types/${id}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          dress_type: newUser.dress_type,
          gender: newUser.gender
        }),
      });

      if (!response.ok) throw new Error('Failed to update dress type');

      navigate('/manage_dresstype');
    } catch (err) {
      setFormError(err.message);
    }
  };

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const handleCancel = () => {
    navigate('/manage_dresstype');
  };

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Edit Dress Type</h2>
                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div className="form-group">
                          <label htmlFor="dress_type">Dress Type</label>
                          <input
                            type="text"
                            id="dress_type"
                            name="dress_type"
                            className="form-control"
                            value={newUser.dress_type}
                            onChange={(e) =>
                              setNewUser({ ...newUser, dress_type: e.target.value })
                            }
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="gender">Gender</label>
                          <select
                            name="gender"
                            id="gender"
                            className="form-control"
                            value={newUser.gender}
                            onChange={(e) =>
                              setNewUser({ ...newUser, gender: e.target.value })
                            }
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Get_DressType;
